<template>
  <div class="baiduQueue">
    <div class="fromClass2">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item label="最近">
          <el-input v-model="searchData.day">
            <template slot="append">天生日</template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn">
      <div>
      </div>
      <div>
        <el-button-group>
          <el-button type="primary" size="small" @click="derive">导出</el-button>
          <el-button type="primary" size="small" @click="refresh">查询</el-button>
        </el-button-group>
      </div>
    </div>
    <div class="tableClass">
      <template>
        <el-table
          ref="multipleTable"
          :data="list.list"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="姓名">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              {{scope.row.tel}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="性别">
            <template slot-scope="scope">
              {{scope.row.tel}}
            </template>
          </el-table-column> -->
          <el-table-column label="出生日期">
            <template slot-scope="scope">
              {{scope.row.birthday}}
            </template>
          </el-table-column>
          <el-table-column label="下一次生日">
            <template slot-scope="scope">
              {{scope.row.next_birthday}}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="birthdayTips(scope.row)"
                >生日提醒</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="birthdayTipsList(scope.row)"
                >生日提醒记录</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="1"
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.totalRow"
          size="small"
        ></el-pagination>
      </template>
    </div>
    <el-dialog
      title="生日提醒记录"
      :visible.sync="birthdayTipsListShow"
      width="700px"
      :before-close="handleClose">
      <el-table
          ref="multipleTable"
          :data="birthdayTipsListData"
          tooltip-effect="dark"
          style="width: 100%"
          size="small"
          border
          stripe
          :header-cell-style="{ background: '#545c64', color: '#fff' }"
        >
          <el-table-column label="操作人员">
            <template slot-scope="scope">
              {{scope.row.admin}}
            </template>
          </el-table-column>
          <el-table-column label="操作时间">
            <template slot-scope="scope">
              {{scope.row.create_time}}
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      accountType:'',
      roleType: "",
      page: 1,
      pageSize:10,
      list:{
      },
      searchData:{
        day:''
      },
      birthdayTipsListShow:false,
      birthdayTipsListData:[]
    }
  },
  computed: {
  },
  components: {},
  filters: {
    date1(e) {
      let date = new Date(e);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    }
  },
  methods: {
    birthdayTipsList(e){
      this.$axios.post('/api/birthday/getLog',this.$qs.stringify({id:e.id})).then(res=>{
          if (res.data.code == 1) {
            this.birthdayTipsListData=res.data.data
            this.birthdayTipsListShow=true
          }
      })
    },
    birthdayTips(e){
      this.$confirm(`确认已完成生日提醒吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id:e.id,
          };
          this.$axios.post('/api/birthday/remind',this.$qs.stringify(params)).then(res=>{
              if (res.data.code == 1) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getData()
              }else{
                this.$message.error(res.data.msg);
              }
          })
          
        })
        .catch(() => {});
    },
    handleClose(){
      this.birthdayTipsListShow=false
      this.birthdayTipsListData=[]
    },
    // 查询列表————————————————————————————————————————————————————————
    derive(){
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        day:this.searchData.day||'-1',
        isExport:1
      };
      this.$axios.post('/api/birthday/getList',this.$qs.stringify(params)).then(res=>{
        if (res.data.code == 1){
          const a = document.createElement('a'); // 创建一个HTML 元素
          let url = res.data.data;
          a.setAttribute('download', ''); //download属性
          a.setAttribute('href', url); // href链接
          a.click();
        }else{
          this.$message.error(res.data.msg);
        }
        
      })
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(e) {
      this.ids = [];
      for (let i = 0; i < e.length; i++) {
        this.ids.push(e[i].id);
      }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getData();
    },
    refresh() {
      this.page = 1;
      this.getData();
    },
    getData() {
      let params = {
        page:this.page,
        pageSize:this.pageSize,
        day:this.searchData.day||'-1'
      };
      this.$axios.post('/api/birthday/getList',this.$qs.stringify(params)).then(res=>{
          this.list=res.data.data
      })
      
    }
  },

  mounted() {
    this.getData();
    this.accountType=Cookie.get('roleType')
  }
};
</script>  
<style lang="scss" scoped>
.el-button--mini{
  margin-top: 10px;
  margin-left: 0 !important;
}
.flex{
  display: flex;
  align-items: center;
  img{
    width: 100px;
    height: 100px;
    margin-right: 50px;
  }
  
}
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.baiduQueue {
  width: calc(100% - 40px);
  padding: 20px 0;
  min-height: 680px;
  .userNumber {
    width: 90%;
    height: 30px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    & > div {
      font-size: 12px;
      color: gray;
      margin-top: 10px;
      span {
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
  .fromClass2 {
    width: 90%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
    display: flex;

    align-content: center;
  }
  .tableClass {
    width: 90%;
    margin: 0 auto;
  }
  //   .el-dialog__body{
  //       padding: 10px 20px;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //   }
}
.btn {
  width: 90%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.initializeTitle {
  font-size: 14px;
  color: gray;
}
.el-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.el-dialog__body {
  padding: 20px;
}
.hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 23px !important;
}
.tableImg {
  width: 34px;
  height: 34px;
}
</style>  


// WEBPACK FOOTER //
// src/pages/birthday/index.vue